module.exports = __webpack_public_path__ + "static/media/stofferingen-52.628b0d1b.jpg";